$j(function() {
	var statusID = $j('.kula-status-bar').data('status-id') || '',
		cookieName = 'kula-status-' + statusID;

	// Check the value of that cookie and show/hide the status bar accordingly
	if ('hidden' === getCookie(cookieName)) {
		$j('.kula-status-bar').hide();
	} else {
		$j('.kula-status-bar').show();
	}

	// Set a cookie and hide the status bar when the dismiss button is clicked
	$j('.kula-status-bar__dismiss-link').click(function(event) {
		setCookie(cookieName, 'hidden', '/');
		$j('.kula-status-bar').hide();
		event.preventDefault();
	});
});

// JS Cookie functions
function setCookie(name, value, path) {
	document.cookie = name + '=' + value + ';path=' + path;
}

function getCookie(cookieName) {
	var name = cookieName + '=';
	var decodedCookie = decodeURIComponent(document.cookie);
	var cookieArray = decodedCookie.split(';');
	for (var i = 0; i < cookieArray.length; i++) {
		var cookie = cookieArray[i];
		while (cookie.charAt(0) == ' ') {
			cookie = cookie.substring(1);
		}

		if (cookie.indexOf(name) == 0) {
			return cookie.substring(name.length, cookie.length);
		}
	}
	return '';
}
